import React, { useEffect } from 'react';
import { useReport } from '../../DataStore/ReportContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import functions from '../../util/functions';
import { numberFormat } from '../../util/araknerdlib';

const PreviousPeriods = () => {
    const { financialPeriods, getFinancialPeriods, selectedYear, dispatch } = useReport();

    useEffect(() => {
        getFinancialPeriods();
    }, []);

    if (!financialPeriods) return <ActivityLoader />;
    if (financialPeriods === '404') return <Notification message='No financial period defined.' />;

    return (
        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
            <style>{`
                .fp-table thead th { 
                    background: #F8FAFC; 
                    color: #64748B; 
                    font-size: 10px; 
                    text-transform: uppercase; 
                    letter-spacing: 0.05em;
                    border: none;
                    padding: 15px 20px;
                }
                .fp-row { transition: all 0.2s; cursor: pointer; border-bottom: 1px solid #F1F5F9; }
                .fp-row:hover { background-color: #F8FAFC; }
                .fp-row.active-period { 
                    background-color: #EFF6FF !important; 
                    border-left: 4px solid #4F46E5; 
                }
                .fp-year-text { font-weight: 700; color: #1E293B; font-size: 14px; }
                .fp-amount { font-weight: 600; color: #475569; font-size: 13px; }
                .fp-profit { font-weight: 800; color: #1E293B; }
                
                .active-badge {
                    background: #ECFDF5; color: #059669; 
                    font-size: 9px; font-weight: 800; 
                    padding: 2px 8px; border-radius: 4px;
                }
            `}</style>


            <div className="rac-head d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div className="rac-headIcon">
                        <i className="fa fa-clock" />
                      </div>
                      <div>
                        <h6 className="rac-title">Financial History</h6>
                        <div className="rac-sub">Select a period to view historical reports</div>
                      </div>
                    </div>
            
                    
                  </div>


            <div className="card-body p-0">
                <div className="table-responsive overflow-auto" style={{ maxHeight: '450px' }}>
                    <table className="table fp-table mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>Financial Period</th>
                                <th className="text-right">Assets</th>
                                <th className="text-right">Liabilities</th>
                                <th className="text-right">Profit/Loss</th>
                                <th className="text-center">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(financialPeriods) && financialPeriods.map((year, index) => {
                                const isActive = selectedYear?.period_id === year.period_id;
                                return (
                                    <tr
                                        key={index}
                                        className={`fp-row ${isActive ? 'active-period' : ''}`}
                                        onClick={() => dispatch({ type: 'selectedYear', payload: year })}
                                    >
                                        <td className="pl-4">
                                            <div className="fp-year-text">
                                                {`${year.opening_date.year} / ${year.closing_date.year}`}
                                            </div>
                                            <small className="text-muted">
                                                Ended {year.closing_date.short_date}
                                            </small>
                                        </td>
                                        <td className="text-right fp-amount align-middle">
                                            {numberFormat(year.total_assets)}
                                        </td>
                                        <td className="text-right fp-amount align-middle">
                                            {numberFormat(year.total_liability)}
                                        </td>
                                        <td className={`text-right align-middle fp-profit ${year.net_profit < 0 ? 'text-danger' : ''}`}>
                                            {numberFormat(year.net_profit)}
                                        </td>
                                        <td className="text-center align-middle">
                                            {year.status * 1 === 1 ? (
                                                <span className="active-badge">ACTIVE</span>
                                            ) : (
                                                <i className="fa fa-lock text-light-gray" style={{ fontSize: '12px', opacity: 0.3 }} />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PreviousPeriods;